import React from 'react';

export interface TabItem {
  label: string;
  value: string;
  count?: number;
}

interface PageTabsProps {
  tabs: TabItem[];
  activeTab: string;
  onChange: (value: string) => void;
  className?: string;
}

/**
 * PageTabs - Thanh điều hướng Tab ngang chuyên dụng cho trang Detail (chuẩn 03-1-SkillDetailLayout.md)
 * Hỗ trợ cuộn ngang trên mobile, hiển thị số lượng (count) và bám chuẩn UI.
 */
export function PageTabs({ tabs, activeTab, onChange, className = '' }: PageTabsProps) {
  return (
    <div className={`flex items-center gap-6 border-b border-os-line overflow-x-auto hide-scrollbar mb-6 ${className}`}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.value;
        return (
          <button
            key={tab.value}
            onClick={() => onChange(tab.value)}
            className={`
              relative pb-4 sm:text-sm text-xs whitespace-nowrap transition-colors
              ${isActive 
                ? 'text-brand-600' 
                : 'text-slate-500 hover:text-slate-800'
              }
            `}
          >
            {tab.label}
            {tab.count !== undefined && (
              <span className={`ml-2 px-1.5 py-0.5 rounded-full text-xs ${
                isActive ? 'bg-brand-100 text-brand-700' : 'bg-slate-50 text-slate-400'
              }`}>
                {tab.count}
              </span>
            )}
            
            {/* Thanh bar ở dưới khi active */}
            {isActive && (
              <span className="absolute bottom-[-1px] left-0 right-0 h-0.5 bg-brand-600 rounded-t-full" />
            )}
          </button>
        );
      })}
    </div>
  );
}
